module.exports = __webpack_public_path__ + "static/media/dmsans-bold-webfont.4f82557d.woff";